<template>
  <div class="course-card" v-if="courseData">
    <div class="card-wrapper">
      <div class="image-wrapper" @click="redirectToDescription">
        <!--src="/img/placeimg_300_200_any.jpg"-->
        <b-img
          v-if="
            courseData.course_properties && courseData.course_properties.imgUrl
          "
          :src="courseData.course_properties.imgUrl"
          fluid
          :alt="courseData.video_id"
        >
        </b-img>
        <!--   <b-img-lazy></b-img-lazy> b-vue also supports lazy load so replace this with that -->
        <!-- https://bootstrap-vue.js.org/docs/components/image/#lazy-loaded-images -->
        <div class="overlay">
          <div class="rating">
            <font-awesome-icon icon="star"></font-awesome-icon>
            <span v-if="courseData.courseReviewResponse">{{
              courseData.courseReviewResponse.courseRating
            }}</span>
          </div>
          <div class="price">₹{{ courseData.price }}</div>
        </div>
      </div>
      <div class="content">
        <b-link
          class="title-text text-capitalize"
          @click="redirectToDescription"
          >{{ courseData.name }}</b-link
        >
        <div class="second-section">
          <div
            class="pill first text-capitalize"
            v-if="courseData.course_properties.subject"
          >
            {{ courseData.course_properties.subject }}
          </div>
          <div class="pill second text-capitalize">
            {{ courseData.teacher_name }}
          </div>
          <div class="status">
            <div class="text">{{ courseData.course_duration }}</div>
            <b-progress height="2px" :value="value" :max="max"></b-progress>
          </div>
        </div>
        <div class="bottom-section" v-if="$route.path === '/student/wishlist'">
          <!--          <div class="date">-->
          <!--            <font-awesome-icon :icon="['far', 'clock']" size="xs" />-->
          <!--            &lt;!&ndash; this for the current live event &ndash;&gt;-->
          <!--            &lt;!&ndash; <font-awesome-icon :icon="['fas', 'clock']" size="xs" /> &ndash;&gt;-->
          <!--            <span>7:30</span>-->
          <!--            <span>Today</span>-->
          <!--          </div>-->
          <!--          <div class="time">3Hrs left</div>-->
          <a
            href=""
            @click.prevent="removeFromWishlist"
            class="remove-from-wishlist"
          >
            <font-awesome-icon icon="heart"></font-awesome-icon>
            <span> Remove from Wishlist</span></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "../../store/store";
import { customerApi } from "../../services/customerApi";

export default {
  name: "course-template",
  data() {
    return {
      value: 45,
      max: 100
    };
  },
  props: {
    courseData: Object
  },
  methods: {
    redirectToDescription() {
      store.dispatch("courses/setSelectedCourse", this.courseData);
      this.$router.push({
        path: "/course_description",
        query: { courseId: this.courseData.course_id }
      });
    },
    removeFromWishlist() {
      const courseData = {
        course_name: this.courseData.name,
        course_id: this.courseData.course_id
      };
      customerApi.removeFromWishlist(courseData).then(res => {
        customerApi.getWishlist();
        this.$bvToast.toast(`Removed from  Wishlist`, {
          autoHideDelay: 500,
          variant: "danger",
          appendToast: true
        });
      });
    },
    calculateCourseProgress() {
      if (this.courseData && this.courseData.videos && this.courseData.videos.length > 0) {
        this.value =
          (this.courseData.videos.length * 100) / this.courseData.total_videos;
      } else {
        this.value = 0;
      }
    }
  },
  mounted() {
    this.calculateCourseProgress();
  }
};
</script>

<style></style>
